/**
 * @fileoverview Footer Component - Site footer with contact information
 * 
 * Provides the main site footer with:
 * - Company logo and copyright information
 * - Dublin and Belgium office contact details
 * - Phone numbers and email links
 * - Developer attribution
 * - Responsive layout design
 * - Professional branding
 * 
 * @component
 * @example
 * <Footer />
 * 
 * @requires React
 * @requires ./Footer.css
 * 
 * @author By John Bellew - Infinia.ie - last updated 10/07/2025
 */

import React, { useState } from 'react';
import './Footer.css';
import InfiniaModal from '../../modals/InfiniaModal';

/**
 * Footer Component
 * 
 * Renders the main site footer with company information and contact details.
 * 
 * Features:
 * - Company logo and branding
 * - Copyright information with dynamic year
 * - Dublin and Belgium office details
 * - Contact information and links
 * - Developer attribution
 * - Responsive grid layout
 * 
 * @component
 * @returns {JSX.Element} Site footer with contact information
 */
function Footer() {
    const [isInfiniaModalOpen, setIsInfiniaModalOpen] = useState(false);

    const handleInfiniaClick = (e) => {
        e.preventDefault();
        setIsInfiniaModalOpen(true);
    };

    const closeInfiniaModal = () => {
        setIsInfiniaModalOpen(false);
    };

    return (
        <footer className='bg-navy'>
            <div className="container footercontainer">
                <div className="box text-white"><img className="mb-4 footerlogo" src="/assets/img/IFlogo-white-small.png" alt="" />
                    <p>© {new Date().getFullYear()} Irish Funds. <br className="d-none d-lg-block" />All rights reserved. <br/>
                    <a href="mailto:info@irishfunds.ie">info@irishfunds.ie</a></p>
                    <p className='mt-2'>
                        <span 
                            className="infinia-link" 
                            onClick={handleInfiniaClick}
                            style={{ cursor: 'pointer' }}
                        >
                            Crafted by Infinia.ie
                        </span>
                    </p>
                    </div>
                <div className="box text-white">
                    <h4 className="widget-title mb-3">Dublin Office</h4>
                    <p>Irish Funds Industry Association,<br/> Ashford House,<br/> 18-22 Tara Street,<br/> Dublin 2, <br/>D02 VX67</p>
                    <span><i className="fa-solid fa-phone-volume"></i> <a href="tel:+353 (0) 1 675 3200">+353 (0) 1 675 3200</a></span> 
                </div>
                <div className="box text-white ">

                <h4 className="widget-title text-white">Belgium Office</h4>
                    <p>Avenue des Arts 44,<br/> 1040 Brussels,<br/> Belgium</p>
                    <span><i className="fa-solid fa-phone-volume"></i> <a href="tel:+32 2 882 5000">+32 2 882 5000</a></span>
                   
                </div>
            </div>
            
            {/* Infinia Modal */}
            <InfiniaModal 
                isOpen={isInfiniaModalOpen} 
                onClose={closeInfiniaModal} 
            />
        </footer>
    );
}

export default Footer;